<template>
  <div
    :class="
      browserSize.xs === true || browserSize.sm === true
        ? 'methods'
        : 'methods2'
    "
  >
    <v-row>
      <v-col>
        <img
          width="220"
          height="150"
          class="iconMargin"
          src="../assets/anatomyTrains.jpg"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
    </v-row>

    <p class="paragraph"><b>Wskazania:</b></p>
    <li class="paragraph2" v-for="item in wskazania" :key="item.index">
      {{ item }}
    </li>

    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis1 }}
        </span>
      </v-col>
    </v-row>

    <p class="paragraph">
      <b>{{ opis2 }}</b>
    </p>
    <li class="paragraph2" v-for="item in list" :key="item.index">
      {{ item }}
    </li>

    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis3 }}
        </span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title:
        "Terapia z wykorzystaniem taśm mięśniowych człowieka - Anatomy Trains",
      wskazania: [
        "zmniejszenie lub całkowite wyeliminowanie dolegliwości bólowych,",
        "poprawa sylwetki, korekcja wad postawy,",
        "zwiększenie świadomości ciała, lepsze samopoczucie we własnym ciele,",
        "wytrzymałość i poczucie własnego ciała, jego ustawienia w przestrzeni (mniejsza podatność na stres oraz kontuzje),",
        "blizny,",
        "wady zgryzu i stawu skroniowo-żuchowego (bruksizm, zaciskanie zębów, bóle głowy),",
        "profilaktyka przedwczesnemu starzeniu się stawów.",
      ],
      opis1:
        "Taśmy mięśniowe człowieka to system połączonych ze sobą mięśni, powięzi i struktur anatomicznych, które tworzą łańcuch biokinematyczny. Są to podłużnej ciągłości mięśniowo-powięziowe taśmy oplatające ciało człowieka, nadające mu kształt oraz wpływające na jego funkcje. W sytuacji, gdy w ciele człowieka występuje grupa mięśni znacznie silniejsza niż jej antagonista, może to skutkować dolegliwościami bólowymi w innej części ciała. W ramach danej taśmy możemy znaleźć kilka, a nawet kilkanaście mięśni, których wzajemne oddziaływanie następuje poprzez powięź. Taśmami przekazywane są informacje o obciążeniu, stabilności, napięciu mięśni i ich elastyczności elastyczność oraz o kompensacjach posturalnych.",
      opis2: "Wyróżnia się następujące taśmy mięśniowe człowieka:",
      list: [
        "taśma powierzchowna przednia,",
        "taśma powierzchowna tylna,",
        "taśma głęboka przednia,",
        "taśma spiralna,",
        "taśma boczna,",
        "taśmy kończyny górnej,",
        "taśmy funkcjonalne.",
      ],
      opis3:
        "Praca fizjoterapeuty z wykorzystaniem taśm mięśniowych człowieka prowadzona jest na mięśniach i powięziach. Jej skutkiem jest uzyskanie somatycznej poprawy równowagi organizmu człowieka. Wykorzystując wiedzę na temat taśm mięśniowych człowieka można wzbogacić rehabilitację o ćwiczenia mające na celu odzyskanie prawidłowej stabilizacji ciała, postawy i ruchu w prawidłowym wzorcu.",
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
.v-application .grey--text {
  color: #414149 !important;
}
.infText {
  margin: auto;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
  text-align: left;
  margin-left: 6vw;
  margin-right: 3vw;
}
.paragraph2 {
  text-align: left;
  margin-left: 7vw;
  margin-right: 3vw;
}
.paragraph3 {
  text-align: justify;
  text-align-last: left;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 1.5em;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
  align-content: center;
  display: flex;
  margin: auto;
}
</style>